<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/146FeuL/tc-custom/9781637151815.jpg?1695676356320" alt="This image is the cover for the book Rick and Morty: vs. Cthulhu  #4, Rick and Morty"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rick and Morty: vs. Cthulhu  #4, Rick and Morty
      </h1>
      <p class="bookDescription body article font2">
        <p>It's R'yleh happening! In the final confrontation of the Smith-Sanchez Lovecraftian horror saga, family turns on family, and the battle for pop culture relevance is waged between Rick and Cthulhu—with devastating stakes.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Zub, Troy Little, Leonardo Ito, Crank!
      </h2>
      
      <p class="authorDescription body article">Jim Zub is a writer, artist and art instructor based in Toronto, Canada. Over the past twenty years he’s worked for a diverse array of publishing, movie and video game clients including Marvel, DC Comics, Disney, Capcom, Hasbro, Cartoon Network, and Bandai-Namco. He juggles his time between being a freelance comic writer and a professor teaching drawing and storytelling courses in Seneca College’s award-winning Animation program. His current comic projects include Conan the Barbarian, the monthly adventures of Robert E. Howard’s legendary sword& sorcery hero, Dungeons & Dragons, the official comic series of the world’s most popular tabletop role-playing game, and Stone Star, a space-fantasy adventure set inside a roving gladiatorial arena.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Oni Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12cc2fe2